import branchFundingSourceEditComponent from './branch_funding_source.edit.component';
import './branch_funding_source.edit.scss';

let branchFundingSourceEditModule = angular.module('branchFundingSourceedit', [
  ])

  .component('branchFundingSourceedit', branchFundingSourceEditComponent)

  .name;

export default branchFundingSourceEditModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/edit/index.js